import { useEffect, useState } from 'react';
import { wasServerRendered } from './ssrData';

/**
 * False for the first client render of a server-rendered document, true afterwards (and always
 * true when there was no server render).
 *
 * This is how a component says "match what the server emitted, then tell me the truth": the
 * server renders the anonymous-visitor view, so the first client render has to as well or
 * React reports a hydration mismatch and throws the markup away.
 */
export function useHydrated(): boolean {
    // False on the server (there are no effects there to flip it), false for the first client
    // render of a server-rendered document, true from the first render of anything else.
    const [hydrated, setHydrated] = useState(
        () => typeof window !== 'undefined' && !wasServerRendered(),
    );

    useEffect(() => {
        if (!hydrated) setHydrated(true);
    }, [hydrated]);

    return hydrated;
}
